package one.healthium.log_weight.ui.internal

import kotlin.time.Instant

@Deprecated("use WeightHistoryUiModel")
data class WeightUiModel(
    val currentWeight: Float,
    val date: Instant?,
)